import React from "react";

export type CoinHandProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 40,
    height: 34,
  },
  medium: {
    width: 40,
    height: 34,
  },
  large: {
    width: 40,
    height: 34,
  },
};

export const CoinHand = React.forwardRef<SVGSVGElement, CoinHandProps>(
  (props, ref) => {
    const { size = "medium", width, height, color = "black" } = props;
    const svgSize = width && height ? { width, height } : sizes[size];
    return (
      <svg
        ref={ref}
        width={svgSize.width}
        height={svgSize.height}
        viewBox="0 0 40 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M39.3747 20.1248H31.2499C30.5608 20.1248 29.9999 20.6857 29.9999 21.3748H26.2499C25.9561 21.3748 25.7218 21.581 25.6546 21.8544L20.531 20.6576C20.1482 20.5669 19.756 20.5997 19.395 20.7482L14.5014 22.7482C13.8608 23.0091 13.3952 23.5419 13.2124 24.1825L2.41716 21.2747C1.84528 21.1013 1.23904 21.206 0.7578 21.5638C0.27656 21.9201 0 22.47 0 23.0685V24.4654C0 25.0935 0.3125 25.6763 0.83436 26.0247L7.77796 30.6527C7.84358 30.6965 7.91858 30.7277 7.99671 30.7434L19.5703 33.1715C19.7109 33.2043 19.8563 33.2215 20 33.2215C20.1437 33.2215 20.2906 33.2043 20.4297 33.1715L25.6249 31.948V31.9996C25.6249 32.3449 25.9046 32.6246 26.2499 32.6246H30.1733C30.3905 32.9965 30.789 33.2496 31.2499 33.2496H39.3747C39.72 33.2496 39.9997 32.9699 39.9997 32.6246V20.7494C39.9997 20.4041 39.72 20.1244 39.3747 20.1244L39.3747 20.1248ZM25.5855 30.6732L20.1419 31.9591C20.0481 31.981 19.9513 31.981 19.8419 31.956L8.37148 29.5482L1.52788 24.9858C1.35288 24.8701 1.24976 24.6748 1.24976 24.4654V23.0686C1.24976 22.8686 1.34194 22.6857 1.50288 22.567C1.66382 22.4482 1.86538 22.4123 2.07476 22.4764L13.2356 25.4826C13.5246 26.3623 14.3543 26.9998 15.3293 26.9998H19.9997V25.7498H15.3293C14.8028 25.7498 14.3746 25.3217 14.3746 24.7951C14.3746 24.4029 14.609 24.0529 14.9731 23.9045L19.8667 21.9045C19.9886 21.8545 20.1182 21.8451 20.2448 21.8748L25.6212 23.131L25.5855 30.6732ZM26.8746 22.6248H29.9996V31.3748H26.8746V22.6248ZM38.7498 32H31.2498V21.3752H38.7498V32Z"
          fill="black"
          stroke="black"
          strokeWidth="0.15"
        />
        <path
          d="M33.75 29.5H36.25V30.75H33.75V29.5Z"
          fill={color}
          stroke={color}
          strokeWidth="0.15"
        />
        <path
          d="M12.8455 11.9312C10.958 13.8265 9.92985 16.3376 9.94549 19.0016C9.95486 20.3672 10.2361 21.6875 10.783 22.9281L11.9268 22.4234C11.4486 21.3406 11.2033 20.1859 11.1955 18.9922C11.1799 16.6641 12.0799 14.4686 13.7299 12.8126C15.3814 11.1532 17.5861 10.2314 19.9363 10.2173H19.9941C24.8189 10.2173 28.7613 14.0923 28.7925 18.8813L30.0425 18.8735C30.0081 13.6095 25.8441 9.32347 20.6253 8.99827V5.74983H25.0005C27.413 5.74983 29.3757 3.78735 29.3757 1.37463C29.3757 1.02932 29.096 0.749634 28.7507 0.749634H23.7507C22.1585 0.749634 20.7663 1.60743 20.0007 2.88243C19.2351 1.60743 17.8429 0.749634 16.2507 0.749634H11.2507C10.9054 0.749634 10.6257 1.02932 10.6257 1.37463C10.6257 3.78711 12.5882 5.74983 15.0009 5.74983H19.3761V8.99827C16.9042 9.14671 14.6009 10.1686 12.8465 11.9311L12.8455 11.9312ZM23.7503 1.99997H28.0627C27.7721 3.42497 26.5096 4.49997 25.0002 4.49997H20.6878C20.9784 3.07497 22.2409 1.99997 23.7503 1.99997ZM15.0003 4.49997C13.4909 4.49997 12.2284 3.42497 11.9378 1.99997H16.2502C17.7596 1.99997 19.0221 3.07497 19.3127 4.49997H15.0003Z"
          fill="black"
          stroke="black"
          strokeWidth="0.15"
        />
        <path
          d="M19.9615 13.2499H19.999C23.0849 13.2499 25.6054 15.5515 25.6238 18.3951L26.8737 18.3858C26.8488 14.8561 23.7706 11.9998 19.9986 11.9998H19.9548C18.1267 12.0107 16.411 12.6841 15.1236 13.8951C13.8236 15.1185 13.1127 16.7435 13.1252 18.4687C13.1314 19.353 13.3252 20.2093 13.7048 21.0156L14.8361 20.4843C14.5361 19.8437 14.3798 19.1624 14.3752 18.4609C14.3658 17.0859 14.9361 15.789 15.9798 14.8062C17.0361 13.8124 18.4517 13.2593 19.9611 13.25L19.9615 13.2499Z"
          fill="black"
          stroke="black"
          strokeWidth="0.15"
        />
      </svg>
    );
  }
);

CoinHand.displayName = "CoinHand";
